/**
 * A simple function to format object to window.open() string features.
 * It formats all values to a number.
 * @example { width: 500, menubar: true, toolbar: false } => 'width=500,menubar=1,toolbar=0'
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Window/open#Window_features
 */
function getFormattedWindowFeatures(object) {
  var keys = Object.keys(object);
  return keys.map(function (key) {
    return "".concat(key, "=").concat(Number(object[key]));
  }).join(',');
}

export default getFormattedWindowFeatures;
